<h2 class="dialog-header">{{consts.TITLE}}
    <mat-icon
        class="dialog-close-button"
        mat-dialog-close
        svgIcon="hub_close"
    >
    </mat-icon>
</h2>
<div class="dialog-body">
    <form [formGroup]="favForm" #localForm="ngForm">
        <div class="fav-dialog-content">
            <p class="desc-text">
                {{consts.LABEL_MAIN}}
                <span class="required text-center">
                    {{consts.LABEL_REQUIRED}}
                 </span>
            </p>
            <mat-dialog-content>
                <label class="form-label">
                    {{consts.LABEL_TOOLS_RESOURCES_MAIN}}
                </label>
                <div
                    formArrayName="toolsItems"
                    *ngFor="let alias of toolsFavFormArray.controls; let toolControlIndex = index"
                    class="row"
                >
                    <div class="col-12">
                        <!-- Custom tools and resource dropdown -->
                        <app-custom-tools-resource-control
                            [formControlName]="toolControlIndex"
                            [listTools]="listTools"
                        >
                        </app-custom-tools-resource-control>
                        <a
                            (click)="removeFavAt(toolControlIndex)"
                            class="remove-source-link"
                        >
                            <mat-icon svgIcon="hub_delete_outline"></mat-icon>
                        </a>
                    </div>
                </div>
                <!-- Add tools link -->
                <div *ngIf="canAddToolsFav" class="row">
                    <div class="col-12 text-center">
                        <a (click)="addToolsFavControl()" class="add-source-link">
                            <mat-icon
                                svgIcon="hub_plus"
                                class="calendar-icon"
                            >
                            </mat-icon>
                            {{consts.LABEL_TOOLS_RESOURCES_ANOTHER}}
                        </a>
                    </div>
                </div>
                <!-- OR -->
                <div class="divider">
                    <span>
                    OR
                    </span>
                </div>
                <!-- Add custom url -->
                <div formArrayName="customItems" class="add-custom-fav">
                    <div *ngFor="let alias of customFavFormArray.controls; let i = index">
                        <div [formGroupName]="i">
                            <div class="row">
                                <div class="col-12">
                                    <label class="form-label">
                                        {{consts.LABEL_CUSTOM_URL_TITLE}}
                                    </label>
                                    <span
                                        *ngIf="alias.get('name')?.invalid && localForm.submitted"
                                        class="required"
                                    >
                                        {{consts.ERROR_CUSTOM_URL_TITLE_REQUIRED}}
                                    </span>
                                    <input
                                        matInput
                                        class="form-element"
                                        formControlName="name"
                                        placeholder="{{consts.PLACEHOLDER_TITLE}}"
                                        type="text"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="form-label">
                                        {{consts.LABEL_CUSTOM_URL_MAIN}}
                                    </label>
                                    <span
                                        *ngIf="alias.get('link')?.invalid && localForm.submitted"
                                        class="required"
                                    >
                                        <ng-container *ngIf="alias.get('link')?.errors?.required">
                                            {{consts.ERROR_CUSTOM_URL_REQUIRED}}
                                        </ng-container>
                                        <ng-container *ngIf="alias.get('link')?.errors?.invalidUrl">
                                            {{consts.ERROR_CUSTOM_URL_INVALID}}
                                        </ng-container>
                                    </span>
                                    <input
                                        matInput
                                        class="form-element"
                                        formControlName="link"
                                        placeholder="{{consts.PLACEHOLDER_URL}}"
                                        type="text"
                                        required
                                    >
                                </div>
                            </div>
                            <!-- Delete icon -->
                            <div class="row">
                                <div class="col-12">
                                    <a
                                        (click)="removeCustomFavAt(i)"
                                        class="remove-source-link"
                                    >
                                        <mat-icon svgIcon="hub_delete_outline"></mat-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add another link -->
                <div *ngIf="canAddCustomFav" class="row">
                    <div class="col-12 text-center">
                        <a (click)="addCustomFavControl()" class="add-source-link">
                            <mat-icon
                                svgIcon="hub_plus"
                                class="calendar-icon"
                            >
                            </mat-icon>
                            {{consts.LABEL_CUSTOM_URL_ANOTHER}}
                        </a>
                    </div>
                </div>
            </mat-dialog-content>
        </div>
            <mat-dialog-actions class="fav-mat-actions">
                <button
                    mat-button
                    mat-dialog-close
                    class="cancel-btn"
                >
                    {{consts.BUTTON_CANCEL}}
                </button>
                <button
                    [disabled]="customFavFormArray.length <= 0 && toolsFavFormArray.length <= 0 ? 'disabled' : null"
                    mat-raised-button
                    class="save-btn"
                    (click)="onSave()"
                >
                    {{consts.BUTTON_SAVE}}
                </button>
            </mat-dialog-actions>
    </form>
</div>
